import styled from "@emotion/styled";
import { GrChip } from "@jnpmedi/grebob";
import { multiLineEllipsis } from "@assets/styles/layout";
import { FilterOption, FilterType, FilterValue } from "./types";

interface FilterChipProps<T> {
  filter: FilterOption<T>;
  currentValues: FilterValue[];
  onContextMenuOpen: (menu: { filter: FilterOption<T>; anchor: HTMLElement }) => void;
  onClear: (key: keyof T & string) => void;
}

export function FilterChip<T>({ filter, currentValues, onContextMenuOpen, onClear }: FilterChipProps<T>) {
  const key = filter.key;
  const isActive = currentValues.length > 0;
  const hasNoOptionsWithSelect = filter.type === FilterType.Select && !filter.options?.length;

  const selectedLabels =
    filter.type === FilterType.Text ? currentValues.map((v) => v.value).join(", ") : currentValues.map((v) => v.label).join(", ");

  const chipLabel = `${filter.label}${isActive ? `: ${selectedLabels}` : ""}`;

  const handleChipClick = (e: React.MouseEvent<HTMLElement>) => {
    if (!isActive) {
      onContextMenuOpen({ filter, anchor: e.currentTarget });
    } else {
      onClear(key);
    }
  };

  return (
    <StyledChip
      size="medium"
      disabled={hasNoOptionsWithSelect}
      color={isActive ? "primary" : "grey"}
      variant="outlined"
      shape="circle"
      label={chipLabel}
      leftIconType={filter.leftIconType}
      rightIconType={isActive ? "circle-x-filled" : "chevron-down"}
      onClick={handleChipClick}
    />
  );
}

const StyledChip = styled(GrChip)`
  cursor: pointer;
  max-width: 220px;
  min-width: 0;

  .GrTypography {
    ${multiLineEllipsis(1)}
  }
`;
